/**
 * Section: Arche féerique (galerie, accordéons, options, prix)
 */

(function () {
  'use strict';

  function parseMoney(value) {
    if (value === null || value === undefined) return 0;
    var str = String(value);
    // Exemple: "+80€", "352 € TTC", "67,00€"
    var match = str.replace(/\s/g, '').match(/[-+]?\d+(?:[.,]\d+)?/);
    if (!match) return 0;
    var normalized = match[0].replace(',', '.');
    var num = parseFloat(normalized);
    return isNaN(num) ? 0 : num;
  }

  function formatAmount(num) {
    if (typeof num !== 'number' || isNaN(num)) return '0';
    var isInt = Math.round(num) === num;
    if (isInt) return String(num);
    // Format FR simple : 2 décimales, virgule
    return num.toFixed(2).replace('.', ',');
  }

  function joinFormattedAmountAndSuffix(formatted, rawSuffix) {
    var t = String(rawSuffix || '').trim();
    if (!t) return formatted;
    return formatted + ' ' + t;
  }

  function postJsonJsConfig() {
    return {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript',
      },
    };
  }

  function productHandleFromPageLink(link) {
    if (!link) return '';
    var s = String(link).trim();
    if (!s) return '';

    // Si lien absolu, on garde le pathname
    if (s.indexOf('http://') === 0 || s.indexOf('https://') === 0) {
      try {
        s = new URL(s).pathname;
      } catch (_e) {}
    }

    // Ex: "/pages/peigne-intemporel" -> "peigne-intemporel"
    s = s.replace(/^\/+/, '');
    s = s.replace(/^pages\//, '').replace(/^products\//, '');
    s = s.replace(/\/+$/, '');
    return s;
  }

  function fetchProductJson(productHandle) {
    if (!productHandle) return Promise.resolve(null);
    var origin = window.location.origin || '';
    var url = origin + '/products/' + productHandle + '.js';
    return fetch(url)
      .then(function (r) { return r.ok ? r.json() : Promise.reject(new Error('product not found')); })
      .then(function (product) { return product || null; })
      .catch(function () { return null; });
  }

  function fetchFirstVariantId(productHandle) {
    return fetchProductJson(productHandle).then(function (product) {
      if (!product || !product.variants || !product.variants.length) return null;
      var v = product.variants.find(function (x) { return x && x.available; }) || product.variants[0];
      return v && v.id ? v.id : null;
    });
  }

  function frequentlyCardSupportsQty(btn) {
    if (!btn) return false;
    var handle = (btn.getAttribute('data-product-handle') || '').trim();
    if (!handle) {
      var link = (btn.getAttribute('data-option-link') || '').trim();
      handle = productHandleFromPageLink(link);
    }
    return handle !== 'douceur-d-agrume' && handle !== 'blanc-sublime' && handle !== 'green-modern' && handle !== 'eclat-violet';
  }

  function getFrequentlyLineQty(btn) {
    if (!btn) return 1;
    if (!frequentlyCardSupportsQty(btn)) return 1;
    var input = btn.querySelector('[data-frequently-qty-input]');
    var q = input ? parseInt(input.value, 10) : 1;
    if (isNaN(q) || q < 1) q = 1;
    return q;
  }

  function shopifyPriceToEuros(priceCents) {
    var n = Number(priceCents);
    if (isNaN(n)) return 0;
    return n / 100;
  }

  function frequentlyPriceSuffix(btn) {
    var inc = (btn.getAttribute('data-option-increment') || '').trim();
    var match = inc.match(/[-+]?\d+(?:[.,]\d+)?\s*(.*)$/);
    return match && match[1] ? match[1].trim() : 'EUR TTC';
  }

  function formatFrequentlyCardPrice(btn, euros) {
    return formatAmount(euros) + ' ' + frequentlyPriceSuffix(btn);
  }

  function getFrequentlyLineUnitPrice(btn) {
    if (!btn) return 0;
    var variantPrice = btn.getAttribute('data-selected-variant-price');
    if (variantPrice !== null && variantPrice !== '') {
      var n = parseFloat(variantPrice);
      if (!isNaN(n)) return n;
    }
    return parseMoney(btn.dataset.optionIncrement);
  }

  function setFrequentlyVariantPrice(btn, priceEuros) {
    if (!btn || isNaN(priceEuros)) return;
    btn.setAttribute('data-selected-variant-price', String(priceEuros));
    var priceEl = btn.querySelector('[class*="__option-price"]');
    if (priceEl) priceEl.textContent = formatFrequentlyCardPrice(btn, priceEuros);
  }

  function applyFrequentlyVariantSelect(btn, select, onPriceChange) {
    if (!btn || !select) return;
    var opt = select.options[select.selectedIndex];
    if (!opt) return;
    btn.setAttribute('data-selected-variant-id', select.value);
    var priceEuros = parseFloat(opt.getAttribute('data-variant-price'));
    if (!isNaN(priceEuros)) setFrequentlyVariantPrice(btn, priceEuros);
    if (typeof onPriceChange === 'function') onPriceChange();
  }

  function resolveFrequentlyCartEntries(buttons) {
    var entries = [];
    buttons.forEach(function (btn) {
      var link = (btn.getAttribute('data-option-link') || '').trim();
      var handle = (btn.getAttribute('data-product-handle') || '').trim() || productHandleFromPageLink(link);
      var sid = (
        btn.getAttribute('data-selected-variant-id') ||
        btn.getAttribute('data-variant-id') ||
        ''
      ).trim();
      entries.push({
        handle: handle,
        variantId: sid && /^\d+$/.test(sid) ? Number(sid) : null,
        title: (btn.getAttribute('data-option-label') || '').trim(),
        quantity: getFrequentlyLineQty(btn),
      });
    });
    return entries;
  }

  function collectLineProperties(container) {
    var props = {};
    var postal = container.querySelector('[data-delivery-postal]');
    if (!postal) postal = container.querySelector('input[name="properties[Code postal ou ville]"]');
    if (postal && postal.value) {
      var pVal = postal.value.trim();
      if (pVal) props['Code postal ou ville'] = pVal;
    }

    var hid = container.querySelector('[data-delivery-date]');
    if (!hid) hid = container.querySelector('input[name="properties[Date de livraison]"]');
    if (hid && hid.value) {
      var dRaw = hid.value.trim();
      if (dRaw) props['Date de livraison'] = dRaw;
    }

    var color = container.querySelector('[data-color-name].is-selected');
    if (color) {
      var colorName = color.getAttribute('data-color-name');
      if (colorName && colorName.trim()) props['Couleur'] = colorName.trim();
    }
    return props;
  }

  function resolveVariantId(container) {
    var selected = container.querySelector('[data-kit-option="size"].is-selected');
    var vid = selected ? (selected.getAttribute('data-variant-id') || '').trim() : '';
    if (!vid && container.dataset && container.dataset.fleursDefaultVariant) {
      vid = String(container.dataset.fleursDefaultVariant).trim();
    }
    if (!vid) {
      var idInput = container.querySelector('input[name="id"][value]');
      if (idInput) vid = String(idInput.value || '').trim();
    }
    if (!vid) {
      try {
        var fromUrl = new URLSearchParams(window.location.search).get('variant');
        if (fromUrl) vid = String(fromUrl).trim();
      } catch (_e1) {}
    }
    vid = vid.replace(/\s/g, '');
    if (!/^\d+$/.test(vid)) return '';
    return vid;
  }

  function wireAddToCart(container, addToCartBtn) {
    if (!addToCartBtn || addToCartBtn.dataset.fleursCartBound === '1') return;
    addToCartBtn.dataset.fleursCartBound = '1';

    addToCartBtn.addEventListener('click', function () {
      if (addToCartBtn.classList.contains('loading') || addToCartBtn.getAttribute('aria-disabled') === 'true') return;

      var vid = resolveVariantId(container);
      if (!vid) {
        window.alert('Variante introuvable. Dans l editeur de theme, renseignez "Produit pour le panier".');
        return;
      }

      var qtyInput = container.querySelector('[data-qty-input]');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      if (isNaN(qty) || qty < 1) qty = 1;
      var variantNum = Number(vid);
      var props = collectLineProperties(container);
      var cartBubble = document.querySelector('cart-dropdown-bubble');
      var routesObj = typeof window.routes !== 'undefined' && window.routes ? window.routes : {};
      var cartUrl = routesObj.cart_add_url || '/cart/add.js';

      // Ajoute le produit principal + tous les "frequently" sélectionnés
      var items = [];
      var mainItem = { id: variantNum, quantity: qty };
      if (Object.keys(props).length > 0) mainItem.properties = props;
      items.push(mainItem);

      var frequentlyButtons = container.querySelectorAll('.peigne-intemporel__option-card[data-kit-option="frequently"][data-option-increment].is-selected, .peigne-intemporel__option-card[data-kit-option="frequently"][data-option-increment][aria-pressed="true"]');
      var frequentlyEntries = resolveFrequentlyCartEntries(frequentlyButtons);

      addToCartBtn.classList.add('loading');
      addToCartBtn.setAttribute('aria-disabled', 'true');

      var cfg = postJsonJsConfig();
      cfg.headers['X-Requested-With'] = 'XMLHttpRequest';
      var addSucceeded = false;

      Promise.all(frequentlyEntries.map(function (entry) {
        if (entry.variantId) return Promise.resolve(entry);
        return fetchFirstVariantId(entry.handle).then(function (variantId) {
          entry.variantId = variantId ? Number(variantId) : null;
          return entry;
        });
      })).then(function (resolvedEntries) {
        var unresolvedEntries = [];
        resolvedEntries.forEach(function (entry) {
          if (!entry.variantId) {
            unresolvedEntries.push(entry.title || entry.handle || 'produit selectionne');
            return;
          }
          var addItem = { id: Number(entry.variantId), quantity: entry.quantity };
          if (Object.keys(props).length > 0) addItem.properties = props;
          items.push(addItem);
        });

        if (unresolvedEntries.length > 0) {
          var unresolvedMsg = 'Produit introuvable pour le panier : ' + unresolvedEntries.join(', ');
          throw new Error(unresolvedMsg);
        }

        var formQuantity = {};
        items.forEach(function (it) {
          if (it && it.id) formQuantity[it.id] = it.quantity;
        });

        var bodyObj = { items: items };
        if (cartBubble && typeof cartBubble.getSectionsToRender === 'function') {
          try {
            bodyObj.sections = cartBubble.getSectionsToRender().map(function (s) { return s.id; });
            bodyObj.sections_url = window.location.pathname;
          } catch (_outer) {}
        }
        cfg.body = JSON.stringify(bodyObj);

        return fetch(cartUrl, cfg)
          .then(function (r) { return r.json(); })
          .then(function (response) {
            if (response.status) {
              var msg = response.description || response.message || 'Impossible d ajouter au panier.';
              if (cartBubble && typeof cartBubble.renderError === 'function') cartBubble.renderError(msg);
              else window.alert(msg);
              return;
            }
            response.quantityItem = formQuantity;
            if (cartBubble && typeof cartBubble.renderContents === 'function') cartBubble.renderContents(response);
            addSucceeded = true;
          });
      }).catch(function (err) {
        console.error(err);
        window.alert(err && err.message ? err.message : 'Une erreur est survenue lors de l ajout au panier.');
      }).finally(function () {
        addToCartBtn.classList.remove('loading');
        addToCartBtn.removeAttribute('aria-disabled');
        if (!addSucceeded) return;
        try {
          if (typeof window.cartAjax !== 'undefined' && window.cartAjax && typeof openCartModal === 'function') openCartModal();
          else if (routesObj.cart_url) window.location.href = routesObj.cart_url;
          else window.location.href = '/cart';
        } catch (_e2) {}
      });
    });
  }


  function setupMobileStickyCart(container, buttonWrap, originalButton) {
    if (!container || !buttonWrap || !originalButton || buttonWrap.dataset.stickyCartBound === '1') return null;
    buttonWrap.dataset.stickyCartBound = '1';

    var stickyWrap = buttonWrap.cloneNode(true);
    stickyWrap.classList.add('peigne-intemporel__sticky-button-wrap');
    stickyWrap.classList.remove('is-visible');
    stickyWrap.setAttribute('aria-hidden', 'true');
    stickyWrap.removeAttribute('data-sticky-cart-bound');

    var stickyWishlist = stickyWrap.querySelector('.peigne-intemporel__wishlist-button');
    if (stickyWishlist) stickyWishlist.remove();

    var stickyButton = stickyWrap.querySelector('[data-fleurs-add-to-cart]') || stickyWrap.querySelector('.peigne-intemporel__button');
    if (stickyButton) {
      stickyButton.removeAttribute('data-fleurs-add-to-cart');
      stickyButton.removeAttribute('data-fleurs-cart-bound');
      stickyButton.addEventListener('click', function () {
        originalButton.click();
      });
    }

    var originalQtyInput = container.querySelector('[data-qty-input]');
    if (stickyButton && originalQtyInput) {
      var stickyQty = document.createElement('div');
      stickyQty.className = 'peigne-intemporel__sticky-qty';

      var stickyMinus = document.createElement('button');
      stickyMinus.type = 'button';
      stickyMinus.className = 'peigne-intemporel__sticky-qty-btn';
      stickyMinus.setAttribute('aria-label', 'Diminuer la quantite');
      stickyMinus.textContent = '-';

      var stickyQtyValue = document.createElement('span');
      stickyQtyValue.className = 'peigne-intemporel__sticky-qty-value';
      stickyQtyValue.setAttribute('aria-live', 'polite');

      var stickyPlus = document.createElement('button');
      stickyPlus.type = 'button';
      stickyPlus.className = 'peigne-intemporel__sticky-qty-btn';
      stickyPlus.setAttribute('aria-label', 'Augmenter la quantite');
      stickyPlus.textContent = '+';

      function clampStickyQty(value) {
        var min = parseInt(originalQtyInput.getAttribute('min'), 10) || 1;
        var max = parseInt(originalQtyInput.getAttribute('max'), 10) || 99;
        var qty = parseInt(value, 10);
        if (isNaN(qty)) qty = min;
        if (qty < min) qty = min;
        if (qty > max) qty = max;
        return qty;
      }

      function syncStickyQty() {
        stickyQtyValue.textContent = String(clampStickyQty(originalQtyInput.value));
      }

      function setOriginalQty(value) {
        originalQtyInput.value = String(clampStickyQty(value));
        originalQtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        syncStickyQty();
      }

      stickyMinus.addEventListener('click', function () {
        setOriginalQty((parseInt(originalQtyInput.value, 10) || 1) - 1);
      });
      stickyPlus.addEventListener('click', function () {
        setOriginalQty((parseInt(originalQtyInput.value, 10) || 1) + 1);
      });
      originalQtyInput.addEventListener('change', syncStickyQty);
      originalQtyInput.addEventListener('input', syncStickyQty);
      originalQtyInput.addEventListener('blur', syncStickyQty);

      stickyQty.appendChild(stickyMinus);
      stickyQty.appendChild(stickyQtyValue);
      stickyQty.appendChild(stickyPlus);
      stickyWrap.insertBefore(stickyQty, stickyButton);
      syncStickyQty();
    }

    document.body.appendChild(stickyWrap);

    var mobileQuery = window.matchMedia('(max-width: 767px)');

    function setStickyVisible(visible) {
      var shouldShow = visible && mobileQuery.matches;
      stickyWrap.classList.toggle('is-visible', shouldShow);
      stickyWrap.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    }

    function originalButtonVisible() {
      var rect = buttonWrap.getBoundingClientRect();
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      return rect.bottom > 0 && rect.top < viewportHeight;
    }

    function updateStickyState() {
      setStickyVisible(!originalButtonVisible());
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        setStickyVisible(!(entry && entry.isIntersecting));
      }, { threshold: 0.01 });
      observer.observe(buttonWrap);
    } else {
      window.addEventListener('scroll', updateStickyState, { passive: true });
    }

    window.addEventListener('resize', updateStickyState);
    if (typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener('change', updateStickyState);
    } else if (typeof mobileQuery.addListener === 'function') {
      mobileQuery.addListener(updateStickyState);
    }

    updateStickyState();
    return stickyButton;
  }

  function initBotteColorQuantity(root) {
    var colorsRoot = root.querySelector('[data-botte-colors]');
    if (colorsRoot) {
      var nameEl = colorsRoot.querySelector('[data-botte-color-name]');
      var swatches = colorsRoot.querySelectorAll('.peigne-intemporel__botte-color-swatch');
      function selectSwatch(btn) {
        if (!btn) return;
        swatches.forEach(function (b) {
          b.classList.remove('is-selected');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-selected');
        btn.setAttribute('aria-pressed', 'true');
        if (nameEl) {
          nameEl.textContent = btn.getAttribute('data-color-name') || '';
        }
      }
      swatches.forEach(function (btn) {
        btn.addEventListener('click', function () {
          selectSwatch(btn);
        });
      });
      if (swatches.length) {
        selectSwatch(swatches[0]);
      }
    }

    var qtyRoot = root.querySelector('[data-botte-qty]');
    if (qtyRoot) {
      var input = qtyRoot.querySelector('[data-qty-input]');
      var minus = qtyRoot.querySelector('[data-qty-minus]');
      var plus = qtyRoot.querySelector('[data-qty-plus]');
      if (input && minus && plus) {
        var qMin = parseInt(input.getAttribute('min'), 10) || 1;
        var qMax = parseInt(input.getAttribute('max'), 10) || 99;

        function clampQty() {
          var v = parseInt(input.value, 10);
          if (isNaN(v)) v = qMin;
          if (v < qMin) v = qMin;
          if (v > qMax) v = qMax;
          input.value = String(v);
        }

        minus.addEventListener('click', function () {
          input.value = String((parseInt(input.value, 10) || qMin) - 1);
          clampQty();
        });
        plus.addEventListener('click', function () {
          input.value = String((parseInt(input.value, 10) || qMin) + 1);
          clampQty();
        });
        input.addEventListener('change', clampQty);
        input.addEventListener('blur', clampQty);
        clampQty();
      }
    }
  }

  function initPeigneIntemporel(container) {
    if (!container) return;

    // Galerie : clic sur une miniature pour mettre à jour l'image principale
    var mainImageWrapper = container.querySelector('.peigne-intemporel__main-image');
    var mainImg = container.querySelector('.peigne-intemporel__main-image img');
    var thumbs = container.querySelectorAll('.peigne-intemporel__thumb');

    // Carrousel miniatures (flèches + scroll horizontal)
    var thumbCarousel = container.querySelector('.peigne-intemporel__thumb-carousel');
    var thumbViewport = container.querySelector('.peigne-intemporel__thumbnails');
    var prevBtn = container.querySelector('.peigne-intemporel__thumb-prev');
    var nextBtn = container.querySelector('.peigne-intemporel__thumb-next');

    function updateCarouselButtons() {
      if (!thumbViewport || !prevBtn || !nextBtn) return;
      var maxScrollLeft = thumbViewport.scrollWidth - thumbViewport.clientWidth;
      var atStart = thumbViewport.scrollLeft <= 0;
      var atEnd = thumbViewport.scrollLeft >= maxScrollLeft - 1;
      prevBtn.disabled = atStart;
      nextBtn.disabled = atEnd;
    }

    if (thumbCarousel && thumbViewport && prevBtn && nextBtn) {
      // Rendre la "fenêtre" des miniatures égale à la largeur de l'image principale
      var syncThumbViewportWidth = function () {
        if (!mainImageWrapper) return;
        var w = mainImageWrapper.getBoundingClientRect().width;
        if (w && w > 0) {
          thumbViewport.style.maxWidth = Math.round(w) + 'px';
          thumbViewport.style.width = Math.round(w) + 'px';
        } else {
          thumbViewport.style.maxWidth = '';
          thumbViewport.style.width = '';
        }
        updateCarouselButtons();
      };

      var step = function () {
        // Avance d'environ 70% de la largeur visible
        return Math.round(thumbViewport.clientWidth * 0.7);
      };

      prevBtn.addEventListener('click', function () {
        thumbViewport.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      nextBtn.addEventListener('click', function () {
        thumbViewport.scrollBy({ left: step(), behavior: 'smooth' });
      });

      thumbViewport.addEventListener('scroll', function () {
        window.requestAnimationFrame(updateCarouselButtons);
      });
      window.addEventListener('resize', function () {
        syncThumbViewportWidth();
      });

      // Etat initial
      syncThumbViewportWidth();
    }

    // Sélection par défaut (première miniature) si aucune n'est active
    if (thumbs && thumbs.length > 0) {
      var anyActive = false;
      thumbs.forEach(function (t) {
        if (t.classList.contains('is-active')) anyActive = true;
      });
      if (!anyActive) {
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumbs[0].classList.add('is-active');
      }
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var img = thumb.querySelector('img');
        if (img && mainImg) {
          // Utiliser directement l'URL HD prévue côté Liquid (évite les regex qui ne matchent pas toujours)
          var largeSrc = img.dataset.largeSrc;
          if (largeSrc) {
            mainImg.setAttribute('src', largeSrc);
            mainImg.setAttribute('data-lightbox-src', largeSrc);
          } else {
            var src = img.getAttribute('src');
            if (src) {
              mainImg.setAttribute('src', src);
              mainImg.setAttribute('data-lightbox-src', src);
            }
          }
          thumbs.forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        }
      });
    });

    // Accordéons : un seul ouvert à la fois
    var toggles = container.querySelectorAll('[data-accordion-toggle]');
    toggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var accordion = toggle.parentElement;
        if (!accordion) return;
        var group = accordion.parentElement;
        var willOpen = !accordion.classList.contains('is-open');
        if (group) {
          group.querySelectorAll('[data-accordion-toggle]').forEach(function (otherToggle) {
            var other = otherToggle.parentElement;
            if (!other || other === accordion) return;
            other.classList.remove('is-open');
            otherToggle.setAttribute('aria-expanded', 'false');
          });
        }
        accordion.classList.toggle('is-open', willOpen);
        toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      });
    });

    // Fleurs / matériel : « Voir tous » → affiche le reste des options (grille normale)
    container.querySelectorAll('[data-kit-view-all]').forEach(function (btn) {
      if (btn.dataset.kitExpandBound === '1') return;
      var kind = btn.getAttribute('data-kit-view-all');
      if (!kind) return;
      var wrap = btn.closest('.peigne-intemporel__option-cards');
      if (!wrap) return;
      var primary = wrap.querySelector('.peigne-intemporel__option-cards-primary');
      var extra = wrap.querySelector('[data-kit-extra="' + kind + '"]');
      if (!extra) return;
      var extraInner = extra.querySelector('.peigne-intemporel__option-cards-extra-inner');
      if (!primary || !extraInner) return;
      btn.dataset.kitExpandBound = '1';
      if (!btn.dataset.kitViewAllLabel) {
        btn.dataset.kitViewAllLabel = btn.textContent.trim();
      }
      var openLabel = btn.dataset.kitViewAllLabel;
      var closeLabel = btn.getAttribute('data-kit-view-less') || 'Voir moins';

      btn.addEventListener('click', function () {
        var show = extra.hidden;
        if (show) {
          extra.hidden = false;
          // Ouvert: le bouton devient le dernier item du bloc des options visibles.
          extraInner.appendChild(btn);
          btn.setAttribute('aria-expanded', 'true');
          btn.textContent = closeLabel;
        } else {
          // Fermé: le bouton revient sur la ligne principale (3 options + bouton).
          primary.appendChild(btn);
          btn.setAttribute('aria-expanded', 'false');
          btn.textContent = openLabel;
          extra.hidden = true;
        }
      });
    });

    // Bloc SEO repliable (Voir plus / Voir moins)
    var seoBlocks = container.querySelectorAll('[data-seo-collapsible]');
    seoBlocks.forEach(function (seoBlock) {
      var content = seoBlock.querySelector('[data-seo-content]');
      var btn = seoBlock.querySelector('[data-seo-toggle]');
      if (!content || !btn) return;

      // Afficher le bouton uniquement si le contenu déborde la hauteur clampée
      var shouldCollapse = content.scrollHeight > content.clientHeight + 4;
      if (!shouldCollapse) {
        btn.hidden = true;
        return;
      }

      btn.hidden = false;
      btn.addEventListener('click', function () {
        var expanded = seoBlock.classList.toggle('is-expanded');
        btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
    });

    // Date & livraison : ouvrir calendrier au clic + afficher date choisie
    var deliveryWrapper = container.querySelector('.peigne-intemporel__delivery');
    var deliveryTrigger = container.querySelector('[data-delivery-trigger]');
    var deliveryText = container.querySelector('[data-delivery-text]');
    var deliveryDateInput = container.querySelector('[data-delivery-date]');
    if (deliveryWrapper && deliveryTrigger && deliveryText && deliveryDateInput) {
      var initialDeliveryText = deliveryText.textContent.trim();

      function formatDateFr(value) {
        if (!value) return initialDeliveryText;
        var d = new Date(value + 'T00:00:00');
        if (isNaN(d.getTime())) return initialDeliveryText;
        return d.toLocaleDateString('fr-FR', {
          day: '2-digit',
          month: 'long',
          year: 'numeric'
        });
      }

      deliveryDateInput.addEventListener('change', function () {
        deliveryText.textContent = formatDateFr(deliveryDateInput.value);
      });

      function openDeliveryCalendar() {
        try {
          if (typeof deliveryDateInput.showPicker === 'function') {
            deliveryDateInput.showPicker();
            return;
          }
        } catch (err) {
          // Fallback below for browsers that expose showPicker but block it
        }

        // Fallback natif
        try {
          deliveryDateInput.focus();
          deliveryDateInput.click();
        } catch (err2) {
          // Dernier fallback: focus simple
          deliveryDateInput.focus();
        }
      }

      deliveryTrigger.addEventListener('click', function (e) {
        e.preventDefault();
        openDeliveryCalendar();
      });

      deliveryTrigger.addEventListener('pointerdown', function () {
        openDeliveryCalendar();
      });

      deliveryWrapper.addEventListener('click', function (e) {
        if (e.target === deliveryDateInput) return;
        e.preventDefault();
        openDeliveryCalendar();
      });
    }

    initBotteColorQuantity(container);

    // Sélections (taille / fleurs / matériel / fréquemment) + recalcul du prix
    var priceEl = container.querySelector('.peigne-intemporel__price');
    var addToCartBtn = container.querySelector('[data-fleurs-add-to-cart]');
    if (!addToCartBtn) addToCartBtn = container.querySelector('.peigne-intemporel__button');
    if (!priceEl || !addToCartBtn) return;

    wireAddToCart(container, addToCartBtn);
    var stickyAddToCartBtn = setupMobileStickyCart(container, addToCartBtn.closest('.peigne-intemporel__button-wrap'), addToCartBtn);

    var priceSuffix = priceEl.dataset.priceSuffix || '';
    var basePriceValue = parseMoney(priceEl.dataset.priceValue);

    // Libellé "bouton" après le tiret, sinon on prend le texte complet
    var rawBtnText = addToCartBtn.textContent.trim();
    var labelPart = rawBtnText;
    if (rawBtnText.indexOf('-') !== -1) {
      labelPart = rawBtnText.split('-').slice(1).join('-').trim();
    }

    var state = {
      sizeTotal: basePriceValue,
      flowerInc: 0,
      materialInc: 0,
      frequentlyInc: 0,
      mainQty: 1,
    };

    function updatePriceAndButton() {
      var productUnitTotal = state.sizeTotal + state.flowerInc + state.materialInc;
      var cartTotal = (productUnitTotal * state.mainQty) + state.frequentlyInc;
      var productDisplay = joinFormattedAmountAndSuffix(formatAmount(productUnitTotal), priceSuffix);
      var cartDisplay = joinFormattedAmountAndSuffix(formatAmount(cartTotal), priceSuffix);
      priceEl.textContent = productDisplay;
      addToCartBtn.textContent = cartDisplay + ' - ' + labelPart;
      if (stickyAddToCartBtn) stickyAddToCartBtn.textContent = addToCartBtn.textContent;
    }

    function readMainQty() {
      var input = container.querySelector('[data-qty-input]');
      var q = input ? parseInt(input.value, 10) : 1;
      if (isNaN(q) || q < 1) q = 1;
      return q;
    }

    function updateMainQtyAndButton() {
      state.mainQty = readMainQty();
      updatePriceAndButton();
    }

    var mainQtyInput = container.querySelector('[data-qty-input]');
    var mainQtyMinus = container.querySelector('[data-qty-minus]');
    var mainQtyPlus = container.querySelector('[data-qty-plus]');
    state.mainQty = readMainQty();
    if (mainQtyMinus) mainQtyMinus.addEventListener('click', updateMainQtyAndButton);
    if (mainQtyPlus) mainQtyPlus.addEventListener('click', updateMainQtyAndButton);
    if (mainQtyInput) {
      mainQtyInput.addEventListener('change', updateMainQtyAndButton);
      mainQtyInput.addEventListener('input', updateMainQtyAndButton);
      mainQtyInput.addEventListener('blur', updateMainQtyAndButton);
    }

    // Taille (1 sélection)
    var sizeButtons = container.querySelectorAll('.peigne-intemporel__size-option[data-size-total]');
    if (sizeButtons.length > 0) {
      sizeButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          sizeButtons.forEach(function (b) {
            b.classList.remove('is-selected');
            b.setAttribute('aria-pressed', 'false');
          });
          btn.classList.add('is-selected');
          btn.setAttribute('aria-pressed', 'true');
          state.sizeTotal = parseMoney(btn.dataset.sizeTotal);
          updatePriceAndButton();
        });
      });

      // Par défaut : première taille sélectionnée ; le total part du « Prix (affiché) » si renseigné, sinon du prix du bloc taille
      sizeButtons.forEach(function (b, idx) {
        if (idx === 0) {
          b.classList.add('is-selected');
          b.setAttribute('aria-pressed', 'true');
          var blockTotal = parseMoney(b.dataset.sizeTotal);
          state.sizeTotal = basePriceValue > 0 ? basePriceValue : blockTotal;
        }
      });
      updatePriceAndButton();
    } else {
      updatePriceAndButton();
    }

    // Fleurs (1 sélection)
    var flowerButtons = container.querySelectorAll('.peigne-intemporel__option-card[data-kit-option="flower"][data-option-increment]');
    if (flowerButtons.length > 0) {
      flowerButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          flowerButtons.forEach(function (b) {
            b.classList.remove('is-selected');
            b.setAttribute('aria-pressed', 'false');
          });
          btn.classList.add('is-selected');
          btn.setAttribute('aria-pressed', 'true');
          state.flowerInc = parseMoney(btn.dataset.optionIncrement);
          updatePriceAndButton();
        });
      });
    }

    // Matériel (1 sélection)
    var materialButtons = container.querySelectorAll('.peigne-intemporel__option-card[data-kit-option="material"][data-option-increment]');
    if (materialButtons.length > 0) {
      materialButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          materialButtons.forEach(function (b) {
            b.classList.remove('is-selected');
            b.setAttribute('aria-pressed', 'false');
          });
          btn.classList.add('is-selected');
          btn.setAttribute('aria-pressed', 'true');
          state.materialInc = parseMoney(btn.dataset.optionIncrement);
          updatePriceAndButton();
        });
      });
    }

    // Fréquemment acheté ensemble (sélection multiple)
    var frequentlyButtons = container.querySelectorAll('.peigne-intemporel__option-card[data-kit-option="frequently"][data-option-increment]');

    function ensureFrequentlyVariantPicker(btn) {
      if (!btn) return;
      if (btn.dataset && btn.dataset.variantUiReady === '1') return;
      var link = (btn.getAttribute('data-option-link') || '').trim();
      var handle = (btn.getAttribute('data-product-handle') || '').trim() || productHandleFromPageLink(link);
      if (!handle) return;

      btn.dataset.variantUiReady = '1';
      fetchProductJson(handle).then(function (product) {
        if (!product || !product.variants || product.variants.length <= 1) return;

        var meta = btn.querySelector('.peigne-intemporel__option-meta');
        if (!meta) return;
        if (meta.querySelector('.peigne-intemporel__option-variant')) return;

        var selectWrap = document.createElement('div');
        selectWrap.className = 'peigne-intemporel__option-variant';
        selectWrap.setAttribute('data-frequently-variant', '');
        selectWrap.hidden = !btn.classList.contains('is-selected');
        var select = document.createElement('select');
        select.className = 'peigne-intemporel__option-variant-select';
        select.setAttribute('aria-label', 'Choisir une taille');

        product.variants.forEach(function (v) {
          if (!v || !v.id) return;
          var opt = document.createElement('option');
          opt.value = String(v.id);
          opt.setAttribute('data-variant-price', String(shopifyPriceToEuros(v.price)));
          opt.textContent = v.public_title || v.title || ('Variante ' + String(v.id));
          opt.disabled = v.available === false;
          select.appendChild(opt);
        });

        // Default: 1ère dispo sinon 1ère
        var firstAvailable = (product.variants || []).find(function (v) { return v && v.id && v.available; });
        select.value = firstAvailable && firstAvailable.id ? String(firstAvailable.id) : (select.options[0] ? select.options[0].value : '');

        function stopVariantPropagation(e) {
          e.stopPropagation();
        }

        function syncFrequentlyVariantPrice() {
          applyFrequentlyVariantSelect(btn, select, function () {
            recalcFrequentlyInc();
            updatePriceAndButton();
          });
        }

        selectWrap.addEventListener('click', stopVariantPropagation);
        select.addEventListener('click', stopVariantPropagation);
        select.addEventListener('change', syncFrequentlyVariantPrice);
        syncFrequentlyVariantPrice();

        selectWrap.appendChild(select);

        var openLink = meta.querySelector('.peigne-intemporel__option-open-link');
        if (openLink) meta.insertBefore(selectWrap, openLink);
        else meta.appendChild(selectWrap);
      });
    }

    function ensureFrequentlyQtyWidget(btn) {
      if (!btn || btn.querySelector('[data-frequently-qty]')) return;
      if (!frequentlyCardSupportsQty(btn)) return;

      var meta = btn.querySelector('.peigne-intemporel__option-meta');
      if (!meta) return;

      var mainQty = container.querySelector('[data-qty-input]');
      var qMin = mainQty ? parseInt(mainQty.getAttribute('min'), 10) || 1 : 1;
      var qMax = mainQty ? parseInt(mainQty.getAttribute('max'), 10) || 99 : 99;

      var wrap = document.createElement('div');
      wrap.className = 'peigne-intemporel__option-qty';
      wrap.setAttribute('data-frequently-qty', '');
      wrap.hidden = true;

      var widget = document.createElement('div');
      widget.className = 'peigne-intemporel__qty-widget';

      var minus = document.createElement('button');
      minus.type = 'button';
      minus.className = 'peigne-intemporel__qty-btn';
      minus.setAttribute('data-frequently-qty-minus', '');
      minus.setAttribute('aria-label', 'Diminuer la quantité');
      minus.textContent = '−';

      var input = document.createElement('input');
      input.type = 'number';
      input.className = 'peigne-intemporel__qty-input';
      input.setAttribute('data-frequently-qty-input', '');
      input.min = String(qMin);
      input.max = String(qMax);
      input.value = '1';
      input.setAttribute('aria-label', 'Quantité');

      var plus = document.createElement('button');
      plus.type = 'button';
      plus.className = 'peigne-intemporel__qty-btn';
      plus.setAttribute('data-frequently-qty-plus', '');
      plus.setAttribute('aria-label', 'Augmenter la quantité');
      plus.textContent = '+';

      function clampQty() {
        var v = parseInt(input.value, 10);
        if (isNaN(v)) v = qMin;
        if (v < qMin) v = qMin;
        if (v > qMax) v = qMax;
        input.value = String(v);
      }

      function stopPropagation(e) {
        e.stopPropagation();
      }

      minus.addEventListener('click', function (e) {
        stopPropagation(e);
        input.value = String((parseInt(input.value, 10) || qMin) - 1);
        clampQty();
        recalcFrequentlyInc();
        updatePriceAndButton();
      });
      plus.addEventListener('click', function (e) {
        stopPropagation(e);
        input.value = String((parseInt(input.value, 10) || qMin) + 1);
        clampQty();
        recalcFrequentlyInc();
        updatePriceAndButton();
      });
      input.addEventListener('click', stopPropagation);
      input.addEventListener('change', function () {
        clampQty();
        recalcFrequentlyInc();
        updatePriceAndButton();
      });
      input.addEventListener('blur', clampQty);

      widget.appendChild(minus);
      widget.appendChild(input);
      widget.appendChild(plus);

      var qtyLabel = document.createElement('span');
      qtyLabel.className = 'peigne-intemporel__option-qty-label';
      qtyLabel.textContent = 'Quantité';
      wrap.appendChild(qtyLabel);
      wrap.appendChild(widget);

      var openLink = meta.querySelector('.peigne-intemporel__option-open-link');
      if (openLink) meta.insertBefore(wrap, openLink);
      else meta.appendChild(wrap);
    }

    function updateFrequentlyQtyVisibility(btn) {
      var wrap = btn.querySelector('[data-frequently-qty]');
      if (!wrap) return;
      wrap.hidden = !btn.classList.contains('is-selected');
    }

    function updateFrequentlyVariantVisibility(btn) {
      var wrap = btn.querySelector('[data-frequently-variant]') || btn.querySelector('.peigne-intemporel__option-variant');
      if (!wrap) return;
      wrap.hidden = !btn.classList.contains('is-selected');
    }

    function recalcFrequentlyInc() {
      var total = 0;
      frequentlyButtons.forEach(function (b) {
        if (!b.classList.contains('is-selected')) return;
        total += getFrequentlyLineUnitPrice(b) * getFrequentlyLineQty(b);
      });
      state.frequentlyInc = total;
    }
    if (frequentlyButtons.length > 0) {
      frequentlyButtons.forEach(function (btn) {
        btn.addEventListener('click', function (event) {
          var linkTrigger = event.target && event.target.closest ? event.target.closest('[data-option-open-link]') : null;
          if (linkTrigger) {
            var optionCard = linkTrigger.closest('[data-kit-option]');
            var productHandle = (
              linkTrigger.getAttribute('data-product-handle') ||
              (optionCard ? optionCard.getAttribute('data-product-handle') : '') ||
              ''
            ).trim();
            var linkUrl = (linkTrigger.getAttribute('data-option-link') || '').trim();
            if (productHandle) {
              linkUrl = '/products/' + productHandle;
            } else if (linkUrl.indexOf('/pages/') === 0) {
              var pageHandle = linkUrl.split('/pages/').pop().split('?')[0].split('#')[0];
              if (pageHandle.indexOf('decoration-chaise-') === 0) {
                pageHandle = pageHandle.replace('decoration-chaise-', 'decoration-de-chaise-');
              }
              linkUrl = '/products/' + pageHandle;
            }
            if (linkUrl) window.open(linkUrl, '_blank', 'noopener');
            return;
          }
          if (event.target && event.target.closest && event.target.closest('[data-frequently-qty]')) return;
          if (event.target && event.target.closest && (event.target.closest('[data-frequently-variant]') || event.target.closest('.peigne-intemporel__option-variant'))) return;

          ensureFrequentlyVariantPicker(btn);
          ensureFrequentlyQtyWidget(btn);
          var isSelected = btn.classList.contains('is-selected');
          btn.classList.toggle('is-selected', !isSelected);
          btn.setAttribute('aria-pressed', isSelected ? 'false' : 'true');
          updateFrequentlyQtyVisibility(btn);
          updateFrequentlyVariantVisibility(btn);
          recalcFrequentlyInc();
          updatePriceAndButton();
        });
      });
    }
  }

  function run() {
    var sections = document.querySelectorAll('.peigne-intemporel');
    sections.forEach(function (section) {
      initPeigneIntemporel(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // Ré-initialiser après un changement dans le theme editor (Shopify section refresh)
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.peigne-intemporel');
    if (section) initPeigneIntemporel(section);
  });
})();
